module.exports = __webpack_public_path__ + "img/mg4.4668d6ba.jpg";